import React, { memo } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { RadioButton, Tooltip } from "components";
import BankInformation from "components/applicationFormFields/businessInfo/bankInformation";
import { ACHProcessorData } from "globalConstants";

import { ReactComponent as InfoIcon } from "static/images/info-round.svg";
import styles from "./../formSections.module.scss";

type AchBankInformationProps = {
	banks: { [key: string]: any }[];
	setBanks: Function;
	formName: string;
	dropDownHeight: string;
	menuPlacement: string;
	routingExists: boolean;
	formValues: { [key: string]: any };
	tooltipContent?: React.ReactNode | JSX.Element;
};

const AchBankInformation = ({
	banks,
	setBanks,
	formName,
	dropDownHeight,
	menuPlacement,
	routingExists,
	formValues,
	tooltipContent,
}: AchBankInformationProps) => {
	return (
		<>
			<Row className="mb-3">
				<Col>
					<div className={`${styles.inlineItemsHeader} mb-4 d-flex`}>
						{ACHProcessorData.IsApplyBankAccountData.displayName}

						{tooltipContent && (
							<div className={styles.labelIcon}>
								<Tooltip html={tooltipContent}>
									<InfoIcon />
								</Tooltip>
							</div>
						)}
					</div>
					<div className={styles.inlineItems}>
						<Field
							component={RadioButton}
							value={
								ACHProcessorData.IsApplyBankAccountData.Yes
									.value
							}
							className={styles.item}
							name={ACHProcessorData.IsApplyBankAccountData.name}
							label={
								ACHProcessorData.IsApplyBankAccountData.Yes
									.displayName
							}
							type="radio"
							id={`PaymentAuthorizationType-${ACHProcessorData.IsApplyBankAccountData.Yes.value}`}
						/>
						<Field
							component={RadioButton}
							value={
								ACHProcessorData.IsApplyBankAccountData.No.value
							}
							className={styles.item}
							name={ACHProcessorData.IsApplyBankAccountData.name}
							label={
								ACHProcessorData.IsApplyBankAccountData.No
									.displayName
							}
							type="radio"
							id={`PaymentAuthorizationType-${ACHProcessorData.IsApplyBankAccountData.No.value}`}
						/>
					</div>
				</Col>
			</Row>
			<BankInformation
				banks={banks}
				setBanks={setBanks}
				formName={formName}
				dropDownHeight={dropDownHeight}
				menuPlacement={menuPlacement}
				routingExists={routingExists}
				routingName={ACHProcessorData.BillingRouting.name}
				bankName={ACHProcessorData.BillingBank.name}
				accountName={ACHProcessorData.BillingAccount.name}
				accountNameName={ACHProcessorData.BillingAccountName.name}
				additionalLabel="Billing "
				isDisabled={formValues?.isApplyBankAccountData === "true"}
			/>
		</>
	);
};

export default memo(AchBankInformation);
